import React from 'react';
import PropTypes from 'prop-types';
import {
  Chip,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import { Edit as EditIcon, Cancel as CancelIcon } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  coverageChip: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
  },
  actionButton: {
    marginLeft: theme.spacing(1),
  },
}));

const CoverageChip = ({ coverage, onEdit, onCancel }) => {
  const classes = useStyles();

  if (!coverage || !coverage.length || coverage.length === 0) {
    return null;
  }

  const firstCoverage = coverage[0];
  const { startDate, endDate } = firstCoverage;
  const fileCount = coverage.length;

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString();
  };

  return (
    <div className={classes.coverageChip}>
      <Chip
        label={`Coverage active for ${fileCount} file${fileCount > 1 ? 's' : ''} (${formatDate(startDate)} - ${formatDate(endDate)})`}
        color="primary"
        variant="outlined"
      />
      <Tooltip title="Edit Coverage">
        <IconButton
          size="small"
          color="primary"
          className={classes.actionButton}
          onClick={() => onEdit(coverage)}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Cancel Coverage">
        <IconButton
          size="small"
          color="secondary"
          className={classes.actionButton}
          onClick={() => onCancel()}
        >
          <CancelIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>
  );
};

CoverageChip.propTypes = {
  coverage: PropTypes.arrayOf(
    PropTypes.shape({
      startDate: PropTypes.string.isRequired,
      endDate: PropTypes.string.isRequired,
    })
  ),
  onEdit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default CoverageChip;
